import React from 'react';
import '../../App.css';

export default function Register() {
  return <h1 className='register'>REGISTER</h1>;
}